<template>
  <BasicModal
    :width="'960px'"
    :title="'求人ページインポート'"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="card-content parent-box">
      <div class="box-request">
        <p style="text-align: left; padding: 15px;" v-if="!importExcel">
          求人ページ作成する際にExcel形式でのインポートがご利用いただけます。<br/>
          下記のテンプレートのフォーマットに従って作成いただければ <br/>
          一括で求人ページを作成することが可能です。<br/>
          Excelテンプレートは<a href="https://storage.googleapis.com/hr-monster/HRMONSTER_TEMPLATE_v4.0.xlsx" download>こちら</a>から
          ダウンロードできます。
        </p>
        <p style="text-align: left; padding: 15px;" v-else-if="importExcel && importContents.length == 0">
          インポートするデータがありません。
        </p>
        <div style="margin-bottom: 16px;" v-else>
          <p style="text-align: left; padding: 15px;">
            選択中のものが追加/更新されます。
          </p>
          <b-pagination
            style="background: #f0f0f0; border-radius: 8px; width: 95%;"
            :total="importContents.length"
            :current.sync="importPagination.importPages"
            :per-page="30">
          </b-pagination>
        </div>
        <table class="table-box disp-scroll" v-if="importExcel && (importContents.length > 0)">
          <tr>
            <th class="table-th">　</th>
            <th class="table-th" v-for="(h, idx) in importHeader" :key="'name-' + idx">
              {{h}}
            </th>
          </tr>
          <tr v-for="(d, idx) in importContentsCopy" :key="idx">
            <template 
              v-if="
                30 * (importPagination.importPages - 1) <= idx &&
                idx < 30 * importPagination.importPages"
            >
              <td class="table-td" style="white-space: nowrap; overflow: auto;" v-if="!isExistContents(d)">
                <b-checkbox :native-value="d" v-model="importContents" class="import-check"></b-checkbox>新規登録　　
              </td>
              <td class="table-td" style="white-space: nowrap; overflow: auto;" v-else>
                <b-checkbox :native-value="d" v-model="importContents" class="import-check"></b-checkbox>上書き更新　
              </td>
              <td class="table-td" style="overflow: auto;" v-for="(h, idx2) in importHeader" :key="idx2">
                <p>{{d[h]}}</p>
              </td>
            </template>
          </tr>
        </table>
      </div>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <div class="upload-form" v-if="!importExcel">
        <a class="upload-style">
          <label for="file_upload" class="upload-style">
            <a class="button is-primary">
              <span class="mdi mdi-image" style="margin-right: 10px;"></span>Excelをアップロード/インポートする
            </a>
            <input type="file" id="file_upload" @change="excelImport">
          </label>
        </a>
      </div>
      <button class="button" @click="cancel" v-if="importExcel">
        戻る
      </button>
      <button class="button is-primary" @click="addImport(importContents)" v-if="importExcel && (importContents.length !=0 || importContentsCopy.length != 0)">
        追加/更新する
      </button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
export default {
  components: {
    BasicModal,
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: true,
    },
    addImport: {
      type: Function,
      required: true
    },
    allcontents: {
      type: Array,
      required: true
    },
    getAllContentsList: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      importExcel: false,
      importHeader: [
        '公開 / \n非公開',
        'タイトル',
        '表示タグ',
        '管理タグ',
        '職種',
        '雇用形態',
        '仕事内容',
        '応募資格・条件・\n求める人材',
        '勤務地',
        '勤務時間',
        '給与',
        '休日休暇',
        '福利厚生',
        '選考フロー',
        '郵便番号',
        '都道府県',
        '市町村区',
        '番地 / その他',
        'GoogleMap用',
        '連携用ID',
        '応募通知先'
      ],
      importPagination: {
        importPages: 1,
        importPerPages: 50
      },
      importContents: [],
      importContentsCopy: [],
    }
  },
  methods: {
    cancel () {
      this.importExcel = false
      this.$emit('cancel', false)
    },
    isExistContents (content) {
      let index = this.$_.findIndex(
        this.allcontents,
        ((obj) => {
          return content['ID'] === obj.contents_id
        })
      )
      return index > -1
    },
    fixdata (data) {
        let o = '',
            l = 0,
            w = 10240
        for (; l < data.byteLength / w; ++l) {
          o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)))
        }
        o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)))
        return o
    },
    excelImport (e) {
      this.getAllContentsList()
      let files = e.target.files || e.dataTransfer.files
      try {
        let reader = new FileReader()
        reader.onload = (e) => {
          try {
            var XLSX = require('xlsx')
            var Utils = XLSX.utils
            var arr = this.fixdata(e.target.result)
            var book = XLSX.read(btoa(arr), {
                type: 'base64',
                cellDates: true,
            })
            var urlListsSheet = book.Sheets['PAGES']
            var henkan = Utils.sheet_to_json(urlListsSheet,{defval: ""})
          } catch (e) {
            alert('ファイルの読み込み時にエラーとなりました。\nお手数をおかけいたしますが、エクセルファイルかどうかご確認の上、再アップロードをお願い致します。\nエラーが続く場合はsupport@hr-monster.ioまでお問い合わせをお願い致します。')
          }
          this.importContents     = this.$_.cloneDeep(henkan)
          this.importContentsCopy = this.$_.cloneDeep(henkan)
          this.importExcel = true
        }
        reader.readAsArrayBuffer(files[0])
      } catch (e) {
        alert('ファイルの読み込み時にエラーとなりました。\nお手数をおかけいたしますが、エクセルファイルかどうかご確認の上、再アップロードをお願い致します。\nエラーが続く場合はsupport@hr-monster.ioまでお問い合わせをお願い致します。')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-form {
  position: relative;
}
.upload-style {
  width: 200px;
  border-radius: 10px;
}
.upload-style > input {
  display: none;
}
.table-box {
  display: block;
  height: calc(75vh - 180px);
  width: 100%;
  table-layout: fixed;
}
.table-td {
  vertical-align: middle;
  border: solid thin #ccc;
  padding: 2px;
  height: 100px;
  max-height: 100px;
  min-height: 100px;
}
.table-td p{
  vertical-align: middle;
  overflow: scroll;
  height: 100px;
  max-height: 100px;
  min-height: 100px;
}
.table-th {
  min-width: 100px;
  max-width: 100px;
  width: 100px;
  padding: 2px 8px;
  text-align: center;
  vertical-align: middle;
  border: solid thin #ccc;
  font-size: 14px;
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/EmploymentPage/ModalExcelImport.vue